module.exports = __webpack_public_path__ + "static/media/email.88cb6e15.png";